// extracted by mini-css-extract-plugin
export default {"documenttypes__Container":"DocumentTypes_documenttypes__Container__r89UN","documenttypes__Item":"DocumentTypes_documenttypes__Item__Ex5NR"};